import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useLang } from "./ctx";
import { MaskLines, Reveal, Label } from "./Motion";

export const Process = () => {
  const { t, lang } = useLang();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 70%", "end 60%"] });
  const w = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <section id="process" className="relative overflow-hidden bg-[#14120F] py-20 text-white sm:py-28 lg:py-40" data-testid="process-section">
      <img src="/assets/excavator.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-[0.14]" />
      <div className="relative mx-auto max-w-[1440px] px-6 lg:px-12">
        <Label light>{t.process.label}</Label>
        <h2 key={lang} className="mt-8 font-display text-4xl font-light leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl">
          <MaskLines lines={[t.process.title[0]]} />
          <MaskLines lines={[t.process.title[1]]} delay={0.12} lineClass="italic text-[#C9A96E]" />
        </h2>
        <div ref={ref} className="relative mt-12 sm:mt-20">
          <div className="absolute left-0 right-0 top-0 hidden h-px bg-white/15 lg:block">
            <motion.div style={{ width: w }} className="h-full bg-[#C9A96E]" />
          </div>
          <div className="grid gap-0 lg:grid-cols-5">
            {t.process.steps.map((s, i) => (
              <Reveal key={s.t} delay={i * 0.08} className="group border-t border-white/15 py-6 sm:py-8 lg:border-t-0 lg:pr-8 lg:pt-10">
                <div data-testid={`process-step-${i + 1}`}>
                  <div className="flex items-center gap-3">
                    <span className="hidden h-2.5 w-2.5 -translate-y-[2.85rem] rounded-full border border-[#C9A96E] bg-[#14120F] lg:block" />
                    <span className="font-mono text-[11px] tracking-[0.3em] text-[#C9A96E]">0{i + 1}</span>
                  </div>
                  <div className="mt-4 font-display text-2xl transition-transform duration-500 group-hover:translate-x-1 lg:mt-0">{s.t}</div>
                  <p className="mt-3 text-sm leading-relaxed text-stone-300">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
